import React from 'react';
import NumberFormat from 'react-number-format';
/**
 * @format
 *@param {string} value 
 */
const numberFormat = ({ value, name }) => {
    return (
        <NumberFormat
            data-testid={name.split(' ').join('_')}
            value={value}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            displayType={'text'}
            prefix={'$'}
        />
    );
};

export { numberFormat };
